import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Volume } from "lucide-react";
export default function EnrollmentForm() {
  const [goal, setGoal] = useState<"no-shows" | "payments" | "both">("both");
  return <section id="enrollment-form" style={{
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(42, 45, 43)",
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    paddingTop: "96px",
    paddingBottom: "96px",
    position: "relative",
    overflow: "hidden",
    backgroundColor: "#FFFCF7"
  }}>
      <div className="page-container">
        <div className="flex flex-col md:flex-row gap-12 items-start">

          
          <div className="w-full md:w-[55%] flex-shrink-0" style={{
          backgroundColor: "#FDFBF8",
          border: "1px solid rgba(31, 58, 46, 0.1)",
          borderRadius: "16px",
          padding: "40px",
          boxShadow: "0 4px 24px rgba(31,58,46,0.07)"
        }}>
            
            <p style={{
            color: "#C8985C",
            fontFamily: 'ui-sans-serif, system-ui, sans-serif',
            fontSize: "11px",
            fontWeight: 600,
            letterSpacing: "0.12em",
            lineHeight: "16px",
            marginBottom: "8px"
          }}>
              60-SECOND SOFT ENROLLMENT
            </p>

            
            <h2 style={{
            color: "rgb(31, 58, 46)",
            fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
            fontSize: "30px",
            fontWeight: "400",
            lineHeight: "36px",
            marginBottom: "8px"
          }}>
              See If Your Spa Qualifies
            </h2>

            
            <p style={{
            color: "rgba(42, 45, 43, 0.7)",
            fontFamily: 'ui-sans-serif, system-ui, sans-serif',
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "20px",
            marginBottom: "24px"
          }}>
              No credit card required. No legal review. Just basic details to configure your dashboard.
            </p>

            
            <form onSubmit={e => e.preventDefault()}>

              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label style={{
                  display: "block",
                  color: "rgba(42, 45, 43, 0.6)",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                  fontSize: "11px",
                  fontWeight: 600,
                  letterSpacing: "0.1em",
                  lineHeight: "16px",
                  marginBottom: "6px"
                }}>
                    BUSINESS NAME
                  </label>
                  <input type="text" placeholder="e.g., Serenity Spa Retreat" className="w-full" style={{
                  backgroundColor: "#FFFCF7",
                  border: "1px solid rgba(31, 58, 46, 0.1)",
                  borderRadius: "14.4px",
                  padding: "10px 14px",
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#2A2D2B",
                  outline: "none",
                  boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif'
                }} />
                </div>
                <div>
                  <label style={{
                  display: "block",
                  color: "rgba(42, 45, 43, 0.6)",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                  fontSize: "11px",
                  fontWeight: 600,
                  letterSpacing: "0.1em",
                  lineHeight: "16px",
                  marginBottom: "6px"
                }}>
                    CONTACT NAME
                  </label>
                  <input type="text" placeholder="Your Full Name" className="w-full" style={{
                  backgroundColor: "#FFFCF7",
                  border: "1px solid rgba(31, 58, 46, 0.1)",
                  borderRadius: "14.4px",
                  padding: "10px 14px",
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#2A2D2B",
                  outline: "none",
                  boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif'
                }} />
                </div>
              </div>

              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label style={{
                  display: "block",
                  color: "rgba(42, 45, 43, 0.6)",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                  fontSize: "11px",
                  fontWeight: 600,
                  letterSpacing: "0.1em",
                  lineHeight: "16px",
                  marginBottom: "6px"
                }}>
                    EMAIL ADDRESS
                  </label>
                  <input type="email" placeholder="you@spa.com" className="w-full" style={{
                  backgroundColor: "#FFFCF7",
                  border: "1px solid rgba(31, 58, 46, 0.1)",
                  borderRadius: "14.4px",
                  padding: "10px 14px",
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#2A2D2B",
                  outline: "none",
                  boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif'
                }} />
                </div>
                <div>
                  <label style={{
                  display: "block",
                  color: "rgba(42, 45, 43, 0.6)",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                  fontSize: "11px",
                  fontWeight: 600,
                  letterSpacing: "0.1em",
                  lineHeight: "16px",
                  marginBottom: "6px"
                }}>
                    PHONE NUMBER
                  </label>
                  <input type="tel" placeholder="(555) 000-0000" className="w-full" style={{
                  backgroundColor: "#FFFCF7",
                  border: "1px solid rgba(31, 58, 46, 0.1)",
                  borderRadius: "14.4px",
                  padding: "10px 14px",
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#2A2D2B",
                  outline: "none",
                  boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif'
                }} />
                  <p style={{
                  color: "rgba(42, 45, 43, 0.5)",
                  fontSize: "11px",
                  fontWeight: 400,
                  marginTop: "4px",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif'
                }}>
                    We'll text you. No spam. Ever.
                  </p>
                </div>
              </div>

              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label style={{
                  display: "block",
                  color: "rgba(42, 45, 43, 0.6)",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                  fontSize: "11px",
                  fontWeight: 600,
                  letterSpacing: "0.1em",
                  lineHeight: "16px",
                  marginBottom: "6px"
                }}>
                    SERVICES OFFERED
                  </label>
                  <Select>
                    <SelectTrigger style={{
                    color: "oklch(0.55 0.006 155)",
                    fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "20px",
                    backgroundColor: "rgb(255, 252, 247)",
                    borderRadius: "14.4px",
                    border: "1px solid rgba(31, 58, 46, 0.1)",
                    padding: "20px 12px",
                    textAlign: "center",
                    width: "auto",
                    minWidth: "144px",
                    height: "42px"
                  }}>
                      <SelectValue placeholder="Select Services" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="massage">Massage Therapy</SelectItem>
                      <SelectItem value="massage-skincare">Massage & Skincare</SelectItem>
                      <SelectItem value="full-spa">Full Spa / Multi-service</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <label style={{
                  display: "block",
                  color: "rgba(42, 45, 43, 0.6)",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                  fontSize: "11px",
                  fontWeight: 600,
                  letterSpacing: "0.1em",
                  lineHeight: "16px",
                  marginBottom: "6px"
                }}>
                    MONTHLY CLIENT VOLUME
                  </label>
                  <Select>
                    <SelectTrigger style={{
                    color: "oklch(0.55 0.006 155)",
                    fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "20px",
                    backgroundColor: "rgb(255, 252, 247)",
                    borderRadius: "14.4px",
                    border: "1px solid rgba(31, 58, 46, 0.1)",
                    padding: "20px 12px",
                    textAlign: "center",
                    width: "auto",
                    minWidth: "138px",
                    height: "42px"
                  }}>
                      <SelectValue placeholder="Select Volume" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="50-150">50 - 150 clients / month</SelectItem>
                      <SelectItem value="151-300">151 - 300 clients / month</SelectItem>
                      <SelectItem value="301+">301+ clients / month</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              </div>

              
              <div className="mb-4">
                <label style={{
                display: "block",
                color: "rgba(42, 45, 43, 0.6)",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                fontSize: "11px",
                fontWeight: 600,
                letterSpacing: "0.1em",
                lineHeight: "16px",
                marginBottom: "6px"
              }}>
                  CURRENT BOOKING/PAYMENT SYSTEM
                </label>
                <input type="text" placeholder="e.g., Vagaro, Square, Mindbody, Pen & Paper" className="w-full" style={{
                backgroundColor: "#FFFCF7",
                border: "1px solid rgba(31, 58, 46, 0.1)",
                borderRadius: "14.4px",
                padding: "10px 14px",
                fontSize: "14px",
                fontWeight: 400,
                color: "#2A2D2B",
                outline: "none",
                boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif'
              }} />
              </div>

              
              <div className="mb-5">
                <label style={{
                display: "block",
                color: "rgba(42, 45, 43, 0.6)",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                fontSize: "11px",
                fontWeight: 600,
                letterSpacing: "0.1em",
                lineHeight: "16px",
                marginBottom: "10px"
              }}>
                  WHAT IS YOUR PRIMARY OPERATIONS GOAL?
                </label>
                <div className="flex flex-wrap gap-2">
                  
                  <button type="button" onClick={() => setGoal("no-shows")} style={{
                  color: goal === "no-shows" ? "rgb(31, 58, 46)" : "rgba(42, 45, 43, 0.7)",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "20px",
                  backgroundColor: "#FFFCF7",
                  borderRadius: "9999px",
                  border: `1px solid rgba(31, 58, 46, ${goal === "no-shows" ? "0.4" : "0.25"})`,
                  padding: "10px 20px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "all 0.15s ease"
                }}>
                    <span style={{
                    width: "14px",
                    height: "14px",
                    borderRadius: "50%",
                    border: `1px solid rgba(31, 58, 46, 0.3)`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    backgroundColor: goal === "no-shows" ? "#1F3A2E" : "transparent"
                  }}>
                      {goal === "no-shows" && <span style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: "#FFFCF7"
                    }} />}
                    </span>
                    Reduce No-shows
                  </button>

                  
                  <button type="button" onClick={() => setGoal("payments")} style={{
                  color: goal === "payments" ? "rgb(31, 58, 46)" : "rgba(42, 45, 43, 0.7)",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "20px",
                  backgroundColor: "#FFFCF7",
                  borderRadius: "9999px",
                  border: `1px solid rgba(31, 58, 46, ${goal === "payments" ? "0.4" : "0.25"})`,
                  padding: "10px 20px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "all 0.15s ease"
                }}>
                    <span style={{
                    width: "14px",
                    height: "14px",
                    borderRadius: "50%",
                    border: `1px solid rgba(31, 58, 46, 0.3)`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    backgroundColor: goal === "payments" ? "#1F3A2E" : "transparent"
                  }}>
                      {goal === "payments" && <span style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: "#FFFCF7"
                    }} />}
                    </span>
                    Streamline Payments
                  </button>

                  
                  <button type="button" onClick={() => setGoal("both")} style={{
                  color: goal === "both" ? "rgb(31, 58, 46)" : "rgba(42, 45, 43, 0.7)",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "20px",
                  backgroundColor: "#FFFCF7",
                  borderRadius: "9999px",
                  border: `1px solid rgba(31, 58, 46, ${goal === "both" ? "0.4" : "0.25"})`,
                  padding: "10px 20px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "all 0.15s ease"
                }}>
                    <span style={{
                    width: "14px",
                    height: "14px",
                    borderRadius: "50%",
                    border: `1px solid rgba(31, 58, 46, 0.3)`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    backgroundColor: goal === "both" ? "#1F3A2E" : "transparent"
                  }}>
                      {goal === "both" && <span style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: "#FFFCF7"
                    }} />}
                    </span>
                    Both
                  </button>
                </div>
              </div>

              
              <button type="submit" className="w-full hover:opacity-90 transition-opacity duration-150" style={{
              color: "oklch(0.28 0.04 160)",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif',
              fontSize: "16px",
              fontWeight: 600,
              lineHeight: "24px",
              borderRadius: "9999px",
              border: "none",
              backgroundColor: "#1F3A2E",
              color: "#FFFFFF",
              letterSpacing: "0.12em",
              padding: "14px 24px",
              cursor: "pointer",
              height: "48px",
              boxShadow: "oklab(0.322641 -0.038253 0.0109689 / 0.2) 0px 10px 15px -3px, oklab(0.322641 -0.038253 0.0109689 / 0.2) 0px 4px 6px -4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%"
            }}>
                COMPLETE SOFT ENROLLMENT
              </button>

              
              <div className="flex items-center justify-center gap-1.5 mt-2">
                <span style={{
                color: "#C8985C",
                display: "flex",
                alignItems: "center"
              }} dangerouslySetInnerHTML={{
                __html: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path><path d="m9 12 2 2 4-4"></path></svg>`
              }} />
                <span style={{
                color: "rgba(42, 45, 43, 0.6)",
                fontSize: "12px",
                fontWeight: 400,
                fontFamily: 'ui-sans-serif, system-ui, sans-serif'
              }}>
                  We hate spam too. Your data stays completely private.
                </span>
              </div>

            </form>
          </div>

          
          <div className="w-full md:w-[40%] flex-shrink-0 flex flex-col justify-between" style={{
          backgroundColor: "#1F3A2E",
          borderRadius: "16px",
          padding: "48px 40px 40px 40px",
          minHeight: "560px"
        }}>
            
            <div>
              <div style={{
              color: "#C8985C",
              fontSize: "40px",
              lineHeight: "1",
              fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
              marginBottom: "24px",
              fontWeight: 700
            }}>
                &ldquo;
              </div>

              
              <p style={{
              color: "rgba(255, 252, 247, 0.9)",
              fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
              fontSize: "24px",
              fontWeight: 300,
              lineHeight: "39px",
              marginBottom: "24px"
            }}>
                Within two weeks of taping the gold PrepayQR code to our three massage tables, our package sales tripled.
              </p>

              
              <p style={{
              color: "rgba(255, 252, 247, 0.75)",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif',
              fontSize: "16px",
              fontWeight: 300,
              lineHeight: "26px"
            }}>
                Our clients scan while resting post-treatment. The relaxation state sells itself. No awkward sales pitch from therapists.
              </p>
            </div>

            
            <div>
              <div style={{
              borderTop: "1px solid rgba(255, 252, 247, 0.15)",
              marginTop: "40px",
              marginBottom: "24px"
            }} />

              
              <div className="flex items-center gap-3">
                <div style={{
                width: "44px",
                height: "44px",
                borderRadius: "50%",
                backgroundColor: "rgba(200, 152, 92, 0.3)",
                border: "1px solid rgba(200, 152, 92, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0
              }}>
                  <span style={{
                  color: "#C8985C",
                  fontSize: "16px",
                  fontWeight: 600,
                  fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif'
                }}>
                    G
                  </span>
                </div>
                <div>
                  <p style={{
                  color: "rgba(255, 252, 247, 0.95)",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "20px"
                }}>
                    Grace, Owner
                  </p>
                  <p style={{
                  color: "#C8985C",
                  fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                  fontSize: "11px",
                  fontWeight: 600,
                  letterSpacing: "0.1em",
                  lineHeight: "16px"
                }}>
                    SERENITY SPAS — 3 LOCATIONS
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}